import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpResponse, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { config } from '../../../../config/pages-config';
import { environment } from '../../../../environments/environment';
import { CustomErrorHandlerService } from '@vfde-fe/ngx-lib/services/custom-error-handler';
import { RouterService } from '../router.service';
import { SpinnerService, SpinnerLoader } from '@vfde-fe/ngx-lib/components/spinner';
import { LOGIN_ERROR_CODES, JWT_NIL_SESSION_HEADRE, MODULE_NAMES } from 'src/app/common/constants/defines';
import { CoreAuthenticationService } from '@vfde-fe/ngx-lib/services/core-authentication';
import { catchError, map } from 'rxjs/operators';
/**
 * HTTPClientInterceptor
 */
@Injectable()
export class HTTPClientInterceptor implements HttpInterceptor {
    /** pages */
    public pages;
    /** pagesConfig */
    private pagesConfig: any;
    /** loader */
    private loader: SpinnerLoader = null;
    /**
     * constructor
     * @param router
     * @param RouterService
     * @param customErrorHandlerService
     * @param spinnerService
     * @param authService
     */
    public constructor (
        private router: Router,
        private RouterService: RouterService,
        private customErrorHandlerService: CustomErrorHandlerService,
        private spinnerService: SpinnerService,
        private authService: CoreAuthenticationService,
        ) {

        this.pagesConfig = config;
    }

    /**
     * intercept
     * @param httpRequest
     * @param next
     * @returns
     */
    public intercept (request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const nilSessionToken = this.authService.getJwtToken();
        const headerConfig = {};
        if (request.url.indexOf(environment.baseUrlNil) !== -1) {
            headerConfig['x-vf-api'] = (new Date().valueOf()).toString();
            headerConfig['x-vf-clientID'] = 'MyVFWeb';
            if (nilSessionToken) {
                headerConfig[JWT_NIL_SESSION_HEADRE] = nilSessionToken;
            }
        }
        this.loader = this.spinnerService.startLoader();

        return next.handle(
            request.clone({setHeaders: headerConfig,
         })).pipe( map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              if (this.loader) {
                  this.spinnerService.endLoader(this.loader, true);
              }

              // need to be handled insted of this condition
              if (!nilSessionToken) {
                  this.authService.setJwtToken(event.headers.get(JWT_NIL_SESSION_HEADRE));
              }
            }

            return event;
          }), catchError((error: HttpErrorResponse) => {

            return this.processErrorResponse (error);
          },
         ));
    }

    /**
     * processErrorResponse to handle generic error on level of application (404,500,401,403,etc..)
     */
     public processErrorResponse (error: HttpErrorResponse) {

        if (error instanceof HttpErrorResponse) {

            if (this.loader) {
                this.spinnerService.endLoader(this.loader, true);
            }

            let errorCode = null;

            try {
                if (error.url && (error.url.indexOf(environment.baseUrlDxl) !== -1 || error.url.indexOf(environment.baseUrlDxlProd) !== -1 || error.url.indexOf(environment.baseUrlDxlPreProd) !== -1 || error.url.indexOf(environment.baseUrlDxlSIT) !== -1 || error.url.indexOf(environment.baseUrlDxlProdV2) !== -1)) {
                    errorCode = error.error.code ? error.error.code : null;
                } else if (error.url.indexOf(environment.baseUrlNil) !== -1 || error.url.indexOf(environment.vluxGate) !== -1) {
                    errorCode = error.error.faultMessage ? error.error.faultMessage.code : null;
                 } else {
                  errorCode = error.error.operationError ? error.error.operationError.code : null;
                }

            } catch (e) {
                // console.log(e);
                // do nothing and not to stop code sequence in case response in not in JSON format
            }
            if (error.url.indexOf(environment.cmsConfigPath) > -1 || error.url.indexOf(environment.cmsErrorMessagesPath) > -1 || error.url.indexOf(environment.cmsWordingPath) > -1) {
                return throwError(error);
            }

            const currentModule = this.RouterService.getCurrentModule() !== '' ? this.RouterService.getCurrentModule() : undefined;
            if (error.status === LOGIN_ERROR_CODES.COMBINATION_ERROR.STATUS && currentModule !== MODULE_NAMES.LOGIN) {
                this.router.navigate([this.pagesConfig.landingPage.route], { queryParams: { 'authentication-required': true } });

                return throwError(error);
            } else {
                if (!errorCode) {
                    this.customErrorHandlerService.getErrorDescription(currentModule, undefined, error.status.toString(), true, true);

                    return throwError(error);
                } else {
                    this.customErrorHandlerService.getErrorDescription(currentModule, errorCode, error.status.toString(), false, true);

                    return throwError(error);
                }
            }
        }
     }
}
